export default __webpack_public_path__ + "static/media/minus_accordion.c7afdda6.svg";